import styled from "styled-components/macro";
import {
    Card as MuiCard,
    CardContent as MuiCardContent,
    CardHeader as MuiCardHeader, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Theme,
    withStyles
} from "@material-ui/core";
import {spacing} from "@material-ui/system";
import React, {FC, useEffect, useState} from "react";
import {Clp} from "../../../../../models/Clp";
import {processClpData} from "../../../../../utils/functions";
import {Box} from "@mui/material";
import NoDataAvailable from "../../../statistic/components/widgets/components/NoDataAvailable";
import FilterButton from "../../../../../components/FilterButton";
import DetailedDataRow from "./DetailedDataRow";

const Card = styled(MuiCard)(spacing);
const CardContent = withStyles((theme: Theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            alignItems: "flex-start",
            flexDirection: "column"
        },
        padding: "16px !important"
    }
}))(MuiCardContent);
const CardHeader = withStyles((theme: Theme) => ({
    root: {
        paddingBottom: "0 !important"
    }
}))(MuiCardHeader);

const FilterBox = styled(Box)`
  .MuiButton-text {
    padding: 0;
  }
  .MuiButton-root {
    min-width: 20px;
    padding: 0;
  }
`

export function createData(
    name: string,
    costLevel: string | number,
    mandatory: boolean,
    amount: string | number,
    cost: string | number,
    q_title: string,
    images: any,
    detailed: any[]
) {
    return {
        name,
        costLevel,
        mandatory,
        amount,
        cost,
        q_title,
        images,
        detailed,
    };
}

type PropsType = {
    data: Clp[] | null
}

const DetailedDataWidget: FC<PropsType> = ({ data }) => {
    const [rows, setRows] = useState<any>([])
    const [filters, setFilters] = useState<any>({
        costLevel: null,
        priority: null,
    })
    const [filteredRows, setFilteredRows] = useState<any>([])

    useEffect(() => {
        if (data && data.length > 0) {
            const processData = processClpData(data)

            setRows(processData.map((i) => {
                const {
                    name,
                    price_level,
                    is_mandatory,
                    count,
                    price,
                    images,
                    q_title
                } = i

                const filteredByAttribute = data.filter((d) => d.attribute === i.attribute)
                // @ts-ignore
                return createData(name, price_level ? price_level : 0, is_mandatory, count, `${Number(count * price).toLocaleString()}€`, q_title, images, filteredByAttribute)
            }))
        }
    }, [data]);

    useEffect(() => {
        if (rows && rows.length > 0) {
            setFilteredRows(rows)
        }
    }, [rows]);

    useEffect(() => {
        if (rows && rows.length > 0) {
            let newRows = rows
            if (filters.costLevel) {
                newRows = newRows.filter((i: any) => i.costLevel === filters.costLevel)
            }
            if (filters.priority !== null) {
                const isMandatory = filters.priority === 'mandatory'
                newRows = newRows.filter((i: any) => i.mandatory === isMandatory)
            }
            setFilteredRows(newRows)
        }
    }, [filters]);

    const handleFilters = (field: string, value: any) => {
        setFilters({ ...filters, [field]: filters[field] === value ? null : value })
    }

    return (
        <Card style={{position: 'relative'}}>
            <CardHeader title={'Detailed issues'}/>
            <CardContent>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">{'Name'}</TableCell>
                                <TableCell align="center">
                                    <FilterButton
                                        title={'Cost level'}
                                        selected={filters.costLevel}
                                        list={[
                                            {name: 'Cost level 1', value: 1},
                                            {name: 'Cost level 2', value: 2},
                                            {name: 'Cost level 3', value: 3},
                                            {name: 'Cost level 4', value: 4},
                                            {name: 'Cost level 5', value: 5},
                                        ]}
                                        onClick={(v) => handleFilters('costLevel', v)}
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <FilterButton
                                        title={'Priority'}
                                        selected={filters.priority}
                                        list={[
                                            {name: 'Mandatory', value: 'mandatory'},
                                            {name: 'Recommended', value: 'recommended'},
                                        ]}
                                        onClick={(v) => handleFilters('priority', v)}
                                    />
                                </TableCell>
                                <TableCell align="center">{'Amount'}</TableCell>
                                <TableCell align="right">{'Cost'}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredRows.length > 0 ? filteredRows.map((row: any) => (
                                <DetailedDataRow key={row.name} row={row}/>
                            )) : null}
                        </TableBody>
                    </Table>
                </TableContainer>
                <NoDataAvailable visible={!!(data && data.length === 0)}/>
            </CardContent>
        </Card>
    )
}

export default DetailedDataWidget